import { Icon } from '@components/icon/Icon';
import { useIsOpen } from '@shared/hooks/useIsOpen';
import {
  parseToDayMonthFormat,
  toISODateFormat,
} from '@shared/utils/dateFormatters';
import { useRestaurantContext } from 'webReservations/context/RestaurantContext';
import typography from '~styles/typography.scss';
import { useAvailabilityContext } from '../context/AvailabilityContext';
import { sendGa4AvailabilityFilterGuestDateTimeStartEvent } from '../availability/gaHelpers';
import styles from './MobileFilterControl.scss';
import { MobileFiltersModal } from './MobileFiltersModal';

export const MobileFilterControl = () => {
  const { selectedGuestCount, selectedDate } = useAvailabilityContext();
  const {
    close: closeMobileFiltersModal,
    isOpen: isMobileFiltersModalOpen,
    open: openMobileFiltersModal,
  } = useIsOpen();
  const { restaurantDetails } = useRestaurantContext();

  const handleMobileFilterOpen = () => {
    openMobileFiltersModal();
    sendGa4AvailabilityFilterGuestDateTimeStartEvent({
      restaurantName: restaurantDetails.name,
    });
  };

  const formattedDate = parseToDayMonthFormat(toISODateFormat(selectedDate));

  return (
    <>
      <button
        aria-label="Mobile Filter Control"
        className={styles.pill}
        onClick={handleMobileFilterOpen}
      >
        <div className={typography.t1}>
          <Icon name="couple" />
          {selectedGuestCount}
        </div>
        <span className={styles.verticalDivider} />
        <div className={typography.t1}>
          <Icon name="calendar" />
          {formattedDate}
        </div>
      </button>
      {isMobileFiltersModalOpen && (
        <MobileFiltersModal onClose={closeMobileFiltersModal} />
      )}
    </>
  );
};
